<template>
  <gd-modal v-if="show" @close="onClose" @closeBG="onClose" @closeESC="onClose" data-qe-id="win-distribution-modal">
    <c-loading-indicator :show="!isReady" />
    <modal-app :class="['winning-distribution', { 'has-tournament-info': tournamentUi }]" s>
      <modal-layout>
        <modal-title>{{ distributionData.name }}</modal-title>
        <modal-content>
          <t-text v-if="tournamentUi" class="tournament-info-section">
            <c-tournament-info
              v-if="tournamentUi.tournamentId"
              :tournament-ui="tournamentUi"
              :info-icon="false"
              :headline="$t('winningDistribution.main.title')"
              class="tournament-info-box"
              gameName
              totalWin
              addedPrize
              entryFee
              restartFee
              competitionDate
              lobbyTime
              registrationDate
              tournamentMode
            />
          </t-text>
          <div class="winning-distribution-table">
            <div class="t-table-header">{{ $t('winningDistribution.table.header') }}</div>
            <table class="t-table" data-qe-id="prizes-table">
              <thead>
                <tr>
                  <td class="rank">{{ $t('winningDistribution.table.rank') }}</td>
                  <td>{{ $t('winningDistribution.table.price') }}</td>
                </tr>
              </thead>

              <tbody>
                <tr v-for="stage in stages" :key="stage.index">
                  <td class="rank">
                    {{ stage.from }} <span v-if="stage.to != stage.from">- {{ stage.to }}</span>
                  </td>
                  <td>{{ stage.prize }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </modal-content>
      </modal-layout>
    </modal-app>
  </gd-modal>
</template>

<script setup lang="ts">
import { ref, Ref, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import events from '@gd/event-bus'
import { useStore } from '@/store'
import { WinningDistribution } from '@/store/modules/winningDistribution'
import CTournamentInfo from '@/components/CTournamentInfo.vue'
import { TournamentUi } from '../model/Tournament'
import { track } from '@/lib/track'
import { jslog } from '@gd/jslog'

const route = useRoute()
const store = useStore()
const isReady = ref(false)
const show = ref(false)
const tId = ref('')
const tournamentUi: Ref<TournamentUi> = ref()
function created() {
  events.$on('tournament-info-modal', (config: { tId: string; tournamentUi: TournamentUi; trackId: string }) => {
    tId.value = config && (config.tId || config.tournamentUi.tournamentId)
    tournamentUi.value = config && config.tournamentUi
    if (tId.value) {
      show.value = true
      isReady.value = false
      store
        .dispatch('winningDistribution/fetchWinningDistributionById', tId.value)
        .then(() => {
          isReady.value = true
        })
        .catch((err) => {
          onClose()
          jslog.send({ name: 'fatal', data: { message: 'could not open winning distribution modal' } })
        })
      track({
        id: 'winning-distribution-modal',
        path: route.fullPath,
        data: (config && config.trackId) || '-',
      })
    } else {
      console.error("can' show tournament info modal - because of missing properties")
    }
  })
}

// watch(show, (newValue: boolean, oldValue: boolean) => {
//   if (oldValue === false) {
//   }
// })

const stages = computed(() => {
  return store.getters['winningDistribution/stages']
})

const distributionData = computed((): WinningDistribution => {
  return store.state.winningDistribution.current
})

function onClose() {
  show.value = false
}

created()
</script>

<style lang="less">
@import '~@npm/@gd/common-styles/dist/color-vars';
@import '~@npm/@gd/common-styles/dist/card';

.winning-distribution {
  text-align: center;
  &.has-tournament-info {
    max-width: 67.8125em;
    .modal-content {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-items: center;
      @media screen and(max-width: 830px) {
        flex-direction: column;
      }
      .winning-distribution-table {
        margin-right: 1.125em;
        margin-left: 1.5625em;
        width: 45%;
        @media screen and(max-width: 830px) {
          margin-left: 1.125em;
          width: 100%;
        }
      }
      .tournament-info-section {
        margin-right: 1.5625em;
        margin-left: 1.125em;
        width: 55%;
        @media screen and(max-width: 830px) {
          margin-top: 0;
          margin-right: 1.125em;
          width: 100%;
        }
        .tournament-info {
          .card-plain();
          text-align: left;
          padding: 1.4375rem;
          .layout {
            padding: 0;
            .headline {
              margin-top: 0.8em;
            }
          }
        }
        &:before {
          display: inline-block;
          content: '';
          margin-bottom: -2.725em;
          width: 19em;
          height: 8.375em;
          background: url('../assets/winning-distribution/qualification_badge.png') center center no-repeat;
          background-size: contain;
        }
      }
    }
  }
  .t-table-header {
    margin-top: 1.5rem;
  }
  .t-table td {
    height: 2.45em;
    padding-top: 0;
    padding-bottom: 0;
  }
  td {
    text-align: left;
    & + td {
      text-align: right;
    }
  }
  .tournament-info--info-layout {
    display: flex;
    flex-direction: column;
    .tournament-info--item {
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>
